import { NgModule } from '@angular/core';
import { ToPlusTimePipe } from './to-plus-time.pipe';

@NgModule({
  declarations: [ToPlusTimePipe],
  exports: [ToPlusTimePipe],
})
export class ToPlusTimeModule {}
